import {
  BiVizStyle,
  BiVizStyleOption,
  kBiVizStyleDefaults,
} from '@euler/model/bi/viz';

/**
 * The style with one option set, or cleared (back to the theme) when
 * `value` is undefined. An empty style is no style.
 */
export function biWithStyleOption<K extends BiVizStyleOption>(
  style: BiVizStyle | undefined,
  option: K,
  value: BiVizStyle[K] | undefined,
): BiVizStyle | undefined {
  const next = Object.fromEntries(
    Object.entries({ ...style, [option]: value }).filter(
      ([, entry]) => entry !== undefined,
    ),
  ) as BiVizStyle;
  return Object.keys(next).length ? next : undefined;
}

type Objects = Exclude<
  keyof typeof kBiVizStyleDefaults,
  'gridLines' | 'dataLabels' | 'axes' | 'pie'
>;

/**
 * An object option with some fields changed: the rest come from what the
 * style has, else the theme, since the wire wants the option whole.
 */
export function biPatchedOption<K extends Objects>(
  style: BiVizStyle | undefined,
  option: K,
  patch: Partial<(typeof kBiVizStyleDefaults)[K]>,
): (typeof kBiVizStyleDefaults)[K] {
  return {
    ...kBiVizStyleDefaults[option],
    ...(style?.[option] as Partial<(typeof kBiVizStyleDefaults)[K]>),
    ...patch,
  };
}
